"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mutateShiftAttributeDelete = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const error_handler_1 = require("@app/util/error-handler");
const apollo_1 = require("@app/util/apollo");
const query = (0, graphql_tag_1.default) `mutation ShiftAttributeRemoveMutation (
  $workspace: ID!,
  $id: ID!
) {
  shiftAttributeRemove (
    workspace: $workspace
    id: $id
  )
}`;
const mutateShiftAttributeDelete = async (args) => {
    const { errors } = await (0, apollo_1.mutate)(query, {
        variables: args
    });
    (0, error_handler_1.processErrors)(errors);
};
exports.mutateShiftAttributeDelete = mutateShiftAttributeDelete;
exports.default = exports.mutateShiftAttributeDelete;
